<template>
  <img :src="propValue" :style="styles" alt="" />
</template>

<script lang="ts">
export default {
  name: 'VImage',
  props: {
    propValue: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    },
    styles: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>
